export default __webpack_public_path__ + "static/17_37-b402228382300a6b61fe76b13ff8136c.png";